<template>
    <div>
        <form class="mb-4">
            <div class="row">
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label>Email</label>
                        <b-form-input v-model="model.email" type="email" placeholder="Enter your name"></b-form-input>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label>{{$t('Website')}}</label>
                        <b-form-input v-model="model.website" type="text" placeholder></b-form-input>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label>{{$t('Primary phone')}}</label>
                        <b-form-input v-model="model.primaryPhone" type="tel" placeholder="(___)___-____"></b-form-input>
                    </div>
                </div>
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label>{{$t('Secondary phone')}}</label>
                        <b-form-input v-model="model.secondaryPhone" type="tel" placeholder="(___)___-____"></b-form-input>
                    </div>
                </div>
            </div>

            <hr class="mt-4 mb-5"/>

            <div class="row">
                <div class="col-12" v-if="1>2">
                    <div class="form-group">
                        <label>{{$t('Country')}}</label>
                        <b-form-select v-model="model.countryId" type="text" placeholder="Select your country"></b-form-select>
                    </div>
                </div>
                <div class="col-12" v-if="1>2">
                    <div class="form-group">
                        <label>{{$t('Region')}}</label>
                        <b-form-select v-model="model.regionId" type="text" placeholder="Select your region"></b-form-select>
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-group">
                        <label>{{$t('City')}}</label>
                        <b-form-input v-model="model.city" type="text" :placeholder="$t('Ex.: Tashkent')"></b-form-input>
                    </div>
                </div>
                <div class="col-12" v-if="1>2">
                    <div class="form-group">
                        <label>{{$t('ZIP / Post code')}}</label>
                        <b-form-input v-model="model.zip" type="text" placeholder="Type your zip"></b-form-input>
                    </div>
                </div>

                <div class="col-12">
                    <div class="form-group">
                        <label class="mb-1">{{$t('Address')}}</label>

                        <b-form-textarea id="address" v-model="model.address" :rows="2" :max-rows="6"></b-form-textarea>
                    </div>
                </div>
            </div>

            <input type="hidden" v-model="company._v"/>
            <button-loading
                class="btn btn-lg btn-primary mb-3"
                :loading="isSavePending"
                @click="saveCompany()"
            >{{$t('Save')}}
            </button-loading>
        </form>
    </div>
</template>

<script>
    import Navigation from './Navigation.vue';
    import ButtonLoading from '@/components/ButtonLoading'
    import {companyMixins} from './mixins.js'

    export default {
        components: {
            Navigation,
            ButtonLoading
        },
        mixins: [companyMixins],
        watch: {
            model: {
                handler(newValue) {
                    this.company.contacts = newValue;
                },
                deep: true
            },
        },
        data() {
            return {
                model: {},
            };
        },
        created() {
            this.getMyCompany("mine").then(data => {
                this.model = data.contacts || {};
            });
        }
    }
</script>
